module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-thanksgiving-left-9ff40350bf68707709f9fe0ca0c65758.svg";